export const lg_login = {
  login_th: {
    title: "เข้าสู่ระบบ",
    email: "อีเมล",
    email_place: "exam@email.com",
    password: "รหัสผ่าน",
    password_place: "รหัสผ่าน",
    btn_register: "ลงทะเบียน",
    btn_forgot: "ลืมรหัสผ่าน ?",
    btn_login: "เข้าสู่ระบบ",
    messageAlert: "อีเมล หรือ พาสเวิด ไม่ถูกต้อง กรุณาตรวจสอบข้อมูล",
    remember_me: "จำฉันไว้",
    li_hero_title: "เชื่อมต่อกับทีมของคุณ\nทุกที่ทุกเวลา",
    li_hero_subtitle:
      "การประชุมออนไลน์แบบวิดีโอ HD และข้อมูลการประชุมจัดเก็บไว้ในประเทศไทย",
    li_feature1: "วิดีโอ HD และการแชร์หน้าจอ",
    li_feature2: "ปฏิบัติตาม PDPA ข้อมูลจัดเก็บในไทย",
    li_feature3: "สร้างสำหรับธุรกิจไทย",
    li_copyright:
      "© สงวนลิขสิทธิ์ 2026 บริษัท ดิจิทัล คอร์ปอเรท เมเนจเม้นท์ จำกัด",
    li_title: "เข้าสู่ระบบ Dmeets",
    li_subtitle: "กรอกข้อมูลรับรองของคุณเพื่อดำเนินการต่อ",
    li_no_account: "ยังไม่มีบัญชีใช่ไหม?",
    li_start_free: "เริ่มต้นใช้งานฟรี",
    li_back_home: "กลับหน้าหลัก",
  },
  login_en: {
    title: "Login",
    email: "Email",
    email_place: "exam@email.com",
    password: "Password",
    password_place: "Password",
    btn_register: "Sign Up",
    btn_forgot: "Forgot Password?",
    btn_login: "Login",
    messageAlert:
      "Email or Password is incorrect, please check your information",
    remember_me: "Remember me",
    li_hero_title: "Connect with your team\nanytime, anywhere",
    li_hero_subtitle: "HD video meetings with meeting data stored in Thailand",
    li_feature1: "HD video and screen sharing",
    li_feature2: "PDPA compliant, data stored in Thailand",
    li_feature3: "Built for Thai businesses",
    li_copyright:
      "© 2026 Digital Corporate Management Co., Ltd. All rights reserved.",
    li_title: "Sign in to Dmeets",
    li_subtitle: "Enter your credentials to continue",
    li_no_account: "Don't have an account?",
    li_start_free: "Start for free",
    li_back_home: "Back to home",
  },
};
